// extracted by mini-css-extract-plugin
export default {"myMessageWrapper":"MyMessage_myMessageWrapper__iQB9S","myMessage":"MyMessage_myMessage__Q3l2b","myMessageLast":"MyMessage_myMessageLast__nfzBN"};